import React from 'react';
import Layout from '../layout/Layout';
import CtaBand from '../layout/CtaBand';
import Section from '../ui/Section';
import Panel from '../ui/Panel';
import PageHero from '../ui/PageHero';
import Button from '../ui/Button';
import Eyebrow from '../ui/Eyebrow';
import Reveal from '../ui/Reveal';
import ShopCard from '../ui/ShopCard';

const IMG = '/marketing/png';

const FeaturedShops = ({ shops = [] }) => (
  <Layout>
    <PageHero
      tint="sage"
      eyebrow="In the spotlight"
      title="Celebrate a few of our favourite online stores."
      lead="We’re on a mission to help local entrepreneurs grow their businesses online — reaching more customers 24/7, every hour of the day, every day of the year."
    >
      <Button href="/pricing-and-features">Start building today</Button>
    </PageHero>

    {/* SHOP GRID */}
    <Section tone="white" pad="lg">
      {shops.length > 0 ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {shops.map((shop, i) => (
            <Reveal key={shop.slug || shop.url} delay={(i % 3) * 60}>
              <ShopCard shop={shop} />
            </Reveal>
          ))}
        </div>
      ) : (
        <Panel tint="lilac" className="text-center">
          <h2 className="text-h3 font-extrabold text-ink">Featured stores are coming soon.</h2>
          <p className="mt-3 text-body max-w-[44ch] mx-auto">We’re lining up some of our favourite Shopstar stores to show off here.</p>
          <div className="mt-6 flex justify-center"><Button href="/pricing-and-features">Build your store</Button></div>
        </Panel>
      )}
    </Section>

    {/* STARS SPOTLIGHT */}
    <Section tone="cream" pad="lg">
      <Panel tint="lilac" className="grid md:grid-cols-2 gap-10 md:gap-14 items-center">
        <div>
          <Eyebrow>Stars of Shopstar</Eyebrow>
          <h2 className="mt-4 text-h2 font-extrabold text-ink">The best way to get your business online.</h2>
          <p className="mt-4 text-lead text-body max-w-[46ch]">From building a website to launching your store, our easy-to-use tools and 100% South African Customer Success Team take the hassle out of your hustle.</p>
          <div className="mt-7"><Button href="https://www.youtube.com/playlist?list=PL0UmMVlK1tLGH4MFDbYea5iZEeTCSqkEt" target="_blank" rel="noreferrer" variant="secondary" icon={false}>▶ Watch their stories</Button></div>
        </div>
        <img src={`${IMG}/62fa40a1fd7b990a4059ac96_bets-way-photo.png`} alt="A Shopstar maker" loading="lazy" className="w-full rounded-3xl shadow-card" />
      </Panel>
    </Section>

    <CtaBand title="Your store could be next." />
  </Layout>
);

export default FeaturedShops;
